module.exports = __webpack_public_path__ + "static/media/active trophy.d526ca1d.png";